module.exports = __webpack_public_path__ + "img/23.6f056eff.svg";